import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  var valid_map = ['admin', 'editor'];
  return valid_map.indexOf(str.trim()) >= 0;
}
export var validPassword = function validPassword(rule, value, callback) {
  if (value) {
    if (value.length < 10) {
      callback(new Error('密码小于10字符'));
    }
    // if (value.indexOf('(') < -1 || value.indexOf(')') > -1) {
    //   callback(new Error('密码不能包含 ( 或者 ) '))
    // }
    var count = 0;
    if (/[a-z]/.test(value)) {
      count += 1;
    }
    if (/[A-Z]/.test(value)) {
      count += 1;
    }
    if (/[0-9]/.test(value)) {
      count += 1;
    }
    if (/[!@#$%^&*,;\.\/\[\]':"\{\}\(\)\_\+]/.test(value)) {
      count += 1;
    }
    if (count < 3) {
      callback(new Error("\u5BC6\u7801\u5FC5\u987B\u5305\u62EC\u82F1\u6587\u5C0F\u5199\uFF0C\u82F1\u6587\u5927\u5199\uFF0C\u6570\u5B57\uFF0C!@#$%^&*,;./[];':\"{}  ()_+\u5176\u4E2D\u4E09\u79CD"));
    }
    callback();
  } else {
    callback();
  }
};

/**
 * 获取以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数的字符串
 * @method getNumForKeepTwoDecimals
 * @param  value - input组件输入的值
 */
export var getNumForKeepTwoDecimals = function getNumForKeepTwoDecimals(value) {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  var strValue = String(value);
  // 移除非数字和非小数点字符
  strValue = strValue.replace(/[^\d.]/g, '');
  // 处理多个小数点的情况，只保留第一个
  var firstDotIndex = strValue.indexOf('.');
  if (firstDotIndex !== -1) {
    strValue = strValue.slice(0, firstDotIndex + 1) + strValue.slice(firstDotIndex + 1).replace(/\./g, '');
  }
  // 处理前导零
  strValue = strValue.replace(/^0+([1-9])/, '$1');
  // 处理小数点开头的情况
  if (strValue.startsWith('.')) {
    strValue = '0' + strValue;
  }
  // 限制小数位数为两位
  var match = strValue.match(/^\d*(\.?\d{0,2})/);
  return match ? match[0] : '';
};